"use strict";function o(o){return o&&"object"==typeof o&&"default"in o?o:{default:o}}var t=o(require("styled-components")).default.section`
    position: relative;

    > button {
        outline: none;
        background: ${({theme:o})=>o.colors.common.light};
        border: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-radius: 2px;
        box-shadow: ${({theme:o})=>o.shadows.colored};
        padding: 9px 8px;
        cursor: pointer;

        .label {
            margin: 0 0 0 4px;
            padding: 4px 0 3px;
            line-height: 0.8em;
        }

        svg.dropdown {
            transform: rotate(-90deg);
            width: 15px;
            height: auto;
            margin-left: 8px;
        }

        svg:not(.dropdown),
        picture {
            width: 20px;
            height: 20px;
        }

        picture {
            position: relative;

            img {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }
        }
    }

    > ul {
        position: absolute;
        top: 100%;
        background: ${({theme:o})=>o.colors.common.light};
        border-radius: 2px;
        box-shadow: ${({theme:o})=>o.shadows.colored};
        list-style: none;
        display: ${({isOpen:o})=>o?"grid":"none"};
        grid-row-gap: 9px;
        margin: 0;
        padding: 7px 10px;
        width: max-content;
        margin-top: 7px;

        li {
            padding: 0;
            margin: 0;

            &.active {
                button {
                    p {
                        color: ${({theme:o})=>o.colors.primary.default};
                    }
                }
            }

            button {
                background: transparent;
                border: none;
                outline: none;
                display: grid;
                grid-template-columns: auto 1fr;
                grid-column-gap: 9px;
                width: 100%;
                box-sizing: border-box;
                padding: 0;
                margin: 0;
                color: inherit;
                transition: all 0.2s ease-in-out;
                cursor: pointer;

                svg,
                picture {
                    height: 20px;
                    width: 20px;
                }

                picture {
                    position: relative;

                    img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                }

                p {
                    margin: 0;
                    text-align: left;
                }
            }
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
